import {css, unsafeCSS} from 'lit';
import {sbkCoreBreakpointMd} from '@/tokens/variables.js'

const breakpointMd = unsafeCSS(`${sbkCoreBreakpointMd}`);

export const style = css`

    :host {
        --button__border--focus: var(--_button__border--focus, var(--sbkButtonBorderOnLightFocus));
        --secondary-button__bg: var(--_secondary-button__bg, var(--sbkButtonBgColorSecondaryOnLightEnabled));
        --secondary-button__color: var(--_secondary-button__color, var(--sbkButtonFgColorOnLightDefault));
        --secondary-button__bg--hover: var(--_secondary-button__bg--hover, var(--sbkButtonBgColorSecondaryOnLightHover));
        --secondary-button__color--hover: var(--_secondary-button__color--hover, var(--sbkButtonSecondaryFgColorOnLightHover));
        --secondary-button__bg--active: var(--_secondary-button__bg--active, var(--sbkButtonBgColorSecondaryOnLightActive));
        --secondary-button__color--active: var(--_secondary-button__color--active, var(--sbkButtonFgColorOnDarkDefault));
        --secondary-button__bg--focus: var(--_secondary-button__bg--focus, var(--sbkButtonBgColorSecondaryOnLightFocus));
        --secondary-button__color--focus: var(--_secondary-button__color--focus, var(--sbkButtonFgColorOnDarkDefault));
        --secondary-button__bg--disabled: var(--_secondary-button__bg--disabled, var(--sbkButtonBgColorSecondaryOnLightDisabled));
        --secondary-button__color--disabled: var(--_secondary-button__color--disabled, var(--sbkButtonFgColorOnLightDisabled));
        --secondary-button__border-color: var(--_secondary-button__border-color, var(--sbkButtonBorderOnLightEnabled));
        --secondary-button__border-color--hover: var(--_secondary-button__border-color--hover, var(--sbkButtonBorderOnLightHover));
        --secondary-button__border-color--focus: var(--_secondary-button__border-color--focus, var(--sbkButtonBgColorSecondaryOnLightFocus));
        --secondary-button__border-color--active: var(--_secondary-button__border-color--active, var(--sbkButtonBorderOnLightActive));
        --secondary-button__border-color--disabled: var(--_secondary-button__border-color--disabled, var(--sbkButtonBorderOnLightDisabled));
        --upload__margin-bottom: var(--fileupload__margin-bottom, var(--sbkCoreSpacingMd));
        width: 100%;
    }

    * {
        box-sizing: border-box;
    }

    .input {
        border: none;
        margin: 0 0 var(--sbkCoreSpacingMd) 0;
        padding: 0;

        .label__wrapper + sbk-annotation {
            margin-top: calc(var(--sbkInput3xs) * -1);
            margin-bottom: var(--sbkInput3xs);
        }
    }

    .file-list {
        list-style-type: none;
        padding: 0;
        margin: 10px 0;
    }

    .file-list-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 5px;
        border-radius: var(--sbkFileUploadBorderRadiusDefault);
        color: var(--sbkFileUploadColorFgcolorDefault);
        font: var(--sbkFileUploadTypographyTitle);
        max-width: 720px;
        position: relative;
        overflow: hidden;
    }

    .icon-status {
        padding: var(--sbkFileUploadSpacingIconAreaInsetTopBottom) var(--sbkFileUploadSpacingIconAreaInstLeftRight);
    }

    .file-list-item > p {
        z-index: 1;
        flex: 1;
        margin: 0;
        padding: var(--sbkFileUploadSpacingStatusAreaInsetTop) var(--sbkFileUploadSpacingStatusAreaInsetRight) var(--sbkFileUploadSpacingStatusAreaInsetBottom) var(--sbkFileUploadSpacingStatusAreaInsetLeft);
    }

    .file-list-item span.title {
            overflow-wrap: break-word;
            word-wrap: break-word;
            word-break: break-all;
        font: var(--sbkFileUploadTypographyTitle);
        padding-bottom: var(--sbkFileUploadSpacingStatusAreaGapTitleStatusText);
    }

    .file-list-item span.status {
        hyphens: auto;
        font: var(--sbkFileUploadTypographyStatus);
    }

    sbk-round-button {
        padding-right: var(--sbkFileUploadSpacingIconAreaInstLeftRight);
    }

    .file-uploading {
        background-color: var(--sbkFileUploadColorBgColorInProgress);
    }

    .file-error {
        background-color: var(--sbkFileUploadColorBgColorError);
    }

    .file-success {
        background-color: var(--sbkFileUploadColorBgColorSuccess);
    }

    .upload-button {
        padding: 10px 20px;
        display: inline-flex;
        gap: var(--sbkButton3xs);
        align-items: center;
        outline: 2px solid transparent;
        outline-offset: var(--sbkButtonBorderGapFocus);
        border-radius: var(--sbkButtonBorderRadiusDefault);
        border: none;
        cursor: pointer;
        text-decoration: none;
        fill: currentColor;
    }

    .upload-button[disabled] {
        cursor: not-allowed;
    }

    .upload-button-small {
        font: var(--sbkButtonSmallLabelSm);
        padding: var(--sbkButton2xs) var(--sbkButtonMd);
    }

    .upload-button-large {
        font: var(--sbkButtonLargeLableMd);
        padding: var(--sbkButtonXs) var(--sbkButtonXl);
    }

    .upload-button-adaptive {
        font: var(--sbkButtonSmallLabelSm);
        padding: var(--sbkButton2xs) var(--sbkButtonMd);
    }

    @media screen and (min-width: ${breakpointMd}) {
        .upload-button-adaptive {
            font: var(--sbkButtonLargeLableMd);
            padding: var(--sbkButtonXs) var(--sbkButtonXl);
        }
    }


    .upload-button {
        background-color: var(--secondary-button__bg);
        border: var(--secondary-button__border-color);
        color: var(--secondary-button__color);
    }

    .upload-button--error {
        border: 2px solid var(--sbkFileUploadColorBgColorError);
        color: var(--sbkFileUploadColorBgColorError);
    }

    @media (hover: hover) and (pointer: fine) {
        .upload-button:hover {
            background-color: var(--secondary-button__bg--hover);
            border: var(--secondary-button__border-color--hover);
            color: var(--secondary-button__color--hover);
        }
    }

    .upload-button:active {
        background-color: var(--secondary-button__bg--active);
        border: var(--secondary-button__border-color--active);
        color: var(--secondary-button__color--active);
    }

    .upload-button:focus-visible {
        background-color: var(--secondary-button__bg--focus);
        border-color: var(--secondary-button__border-color--focus);
        color: var(--secondary-button__color--focus);
            outline: var(--button__border--focus);
    }

    .upload-button[disabled] {
        background-color: var(--secondary-button__bg--disabled);
        border: var(--secondary-button__border-color--disabled);
        color: var(--secondary-button__color--disabled);
    }


    .file-input {
        display: none;
    }

  .progress-bar-inner {
    position: absolute;
    max-width: 655px;
    margin-left: 65px;
    height: 100%;
    width: 0;
    background-color: #0000002e;
    transition: width 0.4s ease;
    border-radius: 0 8px 8px 0;
  }

  .hidden {
    display: none;
  }
`;
